import {ImplementedStaticSchemaInterface} from 'schemas/SchemaConstants';

export const ANTIBODY_SCHEMA_INTERFACE_ID = 'ssi_antibody';

// Indicates that the user intends to set up an antibody interface, but hasn't picked one yet.
// Should only be used for this transient state during schema configuration in the UI.
export const UNSET_ANTIBODY_INTERFACE_ID = 'ssi_UNSET_ANTIBODY';

export interface UnsetImplementedAntibodyInterface extends ImplementedStaticSchemaInterface {
  interfaceId: typeof UNSET_ANTIBODY_INTERFACE_ID;
}

export interface ImplementedAntibodyInterface extends ImplementedStaticSchemaInterface {
  interfaceId: typeof ANTIBODY_SCHEMA_INTERFACE_ID;
  formatId: string;
  domainSchemaFieldSpecs: Array<{
    schemaOrInterfaceId: string | null;
    domainType: string;
    specificity: string | null;
  }>;
}

export type DraftImplementedAntibodyInterface =
  | UnsetImplementedAntibodyInterface
  | (Pick<ImplementedAntibodyInterface, 'interfaceId'> & Partial<ImplementedAntibodyInterface>);

export function isAntibodyImplementedInterface(
  implementedInterface: ImplementedStaticSchemaInterface
): implementedInterface is ImplementedAntibodyInterface | DraftImplementedAntibodyInterface {
  return [ANTIBODY_SCHEMA_INTERFACE_ID, UNSET_ANTIBODY_INTERFACE_ID].includes(
    implementedInterface.interfaceId
  );
}

export function isCompleteImplementedAntibodyInterface(
  implementedInterface: DraftImplementedAntibodyInterface
): implementedInterface is ImplementedAntibodyInterface {
  return (
    implementedInterface.interfaceId === ANTIBODY_SCHEMA_INTERFACE_ID &&
    implementedInterface.formatId != null &&
    implementedInterface.domainSchemaFieldSpecs != null
  );
}
